import { Checkbox } from '@mantine/core';

import { Box, Text } from '../index';
import { checkboxStyle, textStyle } from './SelectableButton.css';

export interface SelectableButtonProps {
  /**
   * Controls the text rendered inside the button
   */
  text: string;
  /**
   * Controls whether the button is selected or not
   */
  selected: boolean;
  /**
   * Function that is executed when button is selected
   */
  onClick: () => void;
  /**
   * Function that is executed when mouse enters the button
   */
  onHover: () => void;
  /**
   * Optional prop to control checkbox rendering
   * If true, a checkbox will be rendered next to the text
   */
  withCheckbox?: boolean;

  padding?: 'small' | 'medium' | null | undefined;
}

export const SelectableButton = ({
  text,
  selected,
  withCheckbox = false,
  onClick,
  onHover,
  padding,
}: SelectableButtonProps): JSX.Element => {
  return (
    <Box
      component="button"
      className={checkboxStyle({ status: selected, padding: padding ?? 'medium' })}
      onClick={onClick}
      onMouseEnter={onHover}
      display="flex"
      alignItems="center"
      justifyContent={withCheckbox ? 'center' : 'flexStart'}
      type="button"
      width="full"
      gap={withCheckbox ? 'xsmall' : 'none'}
    >
      {withCheckbox && <Checkbox checked={selected} />}
      <Text weight="demibold" className={textStyle} size={withCheckbox ? 'small' : 'medium'}>
        {text}
      </Text>
    </Box>
  );
};
